import { USER_WORK_AREA } from './UserWorkArea';

export interface CompanyData {
  id: number;
  empresaName: string;
  fullName: string;
  comercialName: string;
}

export default class User {
  id?: number;
  username?: string;
  firstName?: string;
  lastName?: string;
  fullUsername?: string;
  email?: string;
  isAdmin?: boolean;
  isDealer?: boolean;
  isRoot?: boolean;
  isStaff?: boolean;
  canChangePassword?: boolean;
  pendingChangePassword?: boolean;
  sessionid?: string;
  twofaConfigured?: boolean;
  announcements?: any[];
  categories?: string[];
  companyData?: CompanyData;
  globalPerms?: string[];
  workArea?: USER_WORK_AREA;
  notificationsUnread?: number;

  constructor(data: any) {
    this.id = data.id;

    this.username = data.username;

    this.firstName = data.first_name;

    this.lastName = data.last_name;

    this.fullUsername = data.full_username;

    this.email = data.email;

    this.isAdmin = data.is_admin;

    this.isDealer = data.is_dealer;

    this.isRoot = data.is_root;

    this.isStaff = data.is_staff;

    this.canChangePassword = data.can_change_password;

    this.pendingChangePassword = data.pending_change_password;

    this.sessionid = data.sessionid;

    this.twofaConfigured = data['2fa_configured'];

    this.categories = data.categories;

    this.companyData = data.company_data
      ? {
          id: data.company_data.id,
          empresaName: data.company_data.empresa_name,
          fullName: data.company_data.full_name,
          comercialName: data.company_data.comercial_name,
        }
      : undefined;

    this.globalPerms = data.global_perms;

    this.workArea = data.work_area as USER_WORK_AREA;

    this.notificationsUnread = data.notifications_unread;
  }
}
